export class TimerangeModel {
    firstTime = 0;
    lastTime = 1;
}
